import { priceList, currencyFactor } from './calculator'

const getAverageAndPrice = (
    { initialAmount, cap, expectedGrowth },
    tbPrice
) => {
    let tb = initialAmount || 0

    const monthlyEstimates = [tb]
    for (let i = 1; i < 12; i++) {
        tb += expectedGrowth

        if (cap && tb > cap && cap !== 0) tb = cap

        monthlyEstimates.push(tb)
    }

    const averageMonthlyStorage =
        monthlyEstimates.reduce((total, value) => total + value, 0) / 12

    const price = averageMonthlyStorage * tbPrice * currencyFactor
    return {
        price,
        averageMonthlyStorage
    }
}

/**
 * @param {Object<string, Object<string, number>} usage The amount of storage used from all options
 */
export const calculateStorageCost = (usage) => {
    const averageYearlyStorage = {}

    const {
        price: highVelocity,
        averageMonthlyStorage: highVelocityAvgStorage
    } = getAverageAndPrice(
        usage.highVelocity,
        priceList.storage.velocity.tbPrice
    )

    averageYearlyStorage.highVelocity = highVelocityAvgStorage

    const {
        price: highDensity,
        averageMonthlyStorage: highDensityAvgStorage
    } = getAverageAndPrice(usage.highDensity, priceList.storage.density.tbPrice)

    averageYearlyStorage.highDensity = highDensityAvgStorage

    const {
        price: awsGlacier,
        averageMonthlyStorage: awsGlacierAvgStorage
    } = getAverageAndPrice(
        usage.awsGlacier,
        priceList.storage.awsGlacier.tbPrice
    )

    averageYearlyStorage.awsGlacier = awsGlacierAvgStorage

    const {
        price: awsDeepGlacier,
        averageMonthlyStorage: awsDeepGlacierAvgStorage
    } = getAverageAndPrice(
        usage.awsDeepGlacier,
        priceList.storage.awsDeepGlacier.tbPrice
    )

    averageYearlyStorage.awsDeepGlacier = awsDeepGlacierAvgStorage

    return {
        total: highVelocity + highDensity + awsGlacier + awsDeepGlacier,
        sources: { highVelocity, highDensity, awsGlacier, awsDeepGlacier },
        averageYearlyStorage
    }
}
